export const checkItemIsHaveGroup = (item) => {
  return item.isParentGroup === true && !item.hasOwnProperty('childGroup');
};
